import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface ExtendModal {
  AuthNo: string,
  CompanyId: string,
  UserModel: {
    UserId: string
  }
}

export interface ModifyModal {
  RmiAction: string,
  RmiAttachments: Array<string>,
  RmiAuthNo: string,
  RmiCompanyId: string,
  RmiContact?: string,
  RmiEmail?: string,
  RmiFax?: string,
  RmiNote: any[] | string | null,
  RmiPhone?: string,
  RmiStatus: string,
  RmiStatusDescr: string | null,
  RmiSubmittedFileNames: Array<string>,
  RmiUser: string
}

export const getAllowExtendAndModify = (companyId: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_ALLOW_EXTEND_AND_MODIFY_REQUEST });

  return api.authorization.extendAndModify.getAllow(companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_ALLOW_EXTEND_AND_MODIFY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ALLOW_EXTEND_AND_MODIFY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const extendAuth = (extendModel: ExtendModal) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.POST_EXTEND_AUTH_REQUEST });

  return api.authorization.extendAndModify.extend(extendModel)
    .then((res: any) => {

      dispatch({
        type: types.POST_EXTEND_AUTH_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_EXTEND_AUTH_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const modifyAuth = (model: ModifyModal) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authExtendAndModify.isModifying) { return Promise.reject(); }

  dispatch({ type: types.POST_MODIFY_AUTH_REQUEST });

  return api.authorization.extendAndModify.modify(model)
    .then((res: any) => {

      dispatch({
        type: types.POST_MODIFY_AUTH_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_MODIFY_AUTH_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const cancelAuth = (authNo: string, companyId: string, cancelReason: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authExtendAndModify.isCanceling) { return Promise.reject(); }

  dispatch({ type: types.POST_CANCEL_AUTH_REQUEST });

  return api.authorization.extendAndModify.cancel(authNo, companyId, cancelReason)
    .then((res: any) => {

      dispatch({
        type: types.POST_CANCEL_AUTH_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_CANCEL_AUTH_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const expireAuth = (authNo: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authExtendAndModify.isCanceling) { return Promise.reject(); }

  dispatch({ type: types.POST_EXPIRE_AUTH_REQUEST });

  const param = {
    "AuthNo": authNo,
    "CompanyId": companyId,
  };

  return api.authorization.extendAndModify.expire(param)
    .then((res: any) => {

      dispatch({
        type: types.POST_EXPIRE_AUTH_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_EXPIRE_AUTH_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
